import { Component, DestroyRef, inject, Input } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { ZenithComponentsModule } from '@mateco/zenith-webcomponents-angular/dist/zenith-webcomponents-angular';
import { AsyncPipe, NgClass } from '@angular/common';
import { RequestService } from '../../../../service-worker/drive/request.service';
import { RetryStatus } from '../../../../service-worker/drive/request.interface';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-synchronization-status-icon',
  standalone: true,
  imports: [AsyncPipe, NgClass, RouterLink, ZenithComponentsModule],
  templateUrl: './synchronization-status-icon.component.html',
  styleUrl: './synchronization-status-icon.component.scss'
})
export class SynchronizationStatusIconComponent {
  private readonly requestsService = inject(RequestService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly router = inject(Router);

  readonly hasPendingUploads = this.requestsService
    .hasAnyRequestWithStatus$(RetryStatus.PENDING)
    .pipe(takeUntilDestroyed(this.destroyRef));
  readonly hasFailedUploads = this.requestsService
    .hasAnyRequestWithStatus$(RetryStatus.FAILED)
    .pipe(takeUntilDestroyed(this.destroyRef));

  // TODO @deprecated : remove legacy routing once old q.drive UI and handover doesn't differ
  @Input() legacy = false;

  navigate() {
    this.router.navigate([this.legacy ? `synchronization` : `/new/synchronization`]);
  }
}
